export const COOKIES = document.cookie.split(';');

export function cookieExists(key: string): boolean {
  return !!COOKIES.filter((item) => item.includes(key + '=')).length;
}

export function getCookieValue(key: string): string {
  const result = COOKIES.filter(cookie => cookie.includes(key + '='))[0];
  if (result) {
    return result.split('=')[1];
  } else {
    return null;
  }

}

export function unsetCookie(key: string): void {
  // deepcode ignore WebCookieSecureDisabledByDefault: <used for testing purpose>
  document.cookie = `${key}=;secure;expires=${new Date(1970)};`;
}


export function getCookie(name) {
  const v = document.cookie.match('(^|;) ?' + name + '=([^;]*)(;|$)');
  return v ? v[2] : null;
}

export function setCookie(name, value, days) {
  const d = new Date();
  d.setTime(d.getTime() + 24 * 60 * 60 * 1000 * days);
  document.cookie = name + '=' + value + ';Secure;path=/;expires=' + d.toUTCString();
}

export function deleteCookie(name) {
  this.setCookie(name, '', -1);
}

export function deleteCookies() {
  const allCookies = document.cookie.split(';');
  for (let i = 0; i < allCookies.length; i++) {
    this.deleteCookie(allCookies[i]);
  }
}
